module.exports = __webpack_public_path__ + "img/hard-drive.55e8f93e.svg";